/*                                                         */
import { nanoid } from "@otto-ec/global-resources/misc";
import { componentsScope } from "../../../../common/utils/logger.js";

export const sheetScope = /*           */ componentsScope.scope("sheet-v1");

/*                      */
export function computeSheetId() {
  const res = nanoid();
  sheetScope.warn("sheet id is missing, use computed one:", res);
  return res;
}
